export const PAYOUTS_STATUSES = {
    FAILED: 'FAILED',
    PENDING: 'PENDING',
    PAID: 'PAID',
    COMPLETED: 'COMPLETED',
    DECLINED: 'DECLINED',
}
